<template>
    <div>
        <buttonlist
                @help="help"
                @opentable="opentable"                
                @exps="exps"
                ref="SetBtn"
        ></buttonlist>
        <div style="margin-top: 2px">
			<table>
				<tr>
					<td style="width:60px">{{ $t('getapi[4209]') }}</td>
					<td style="width:100px;">
                        <el-input type="text" size="mini" v-model="schedule_no" :readonly="true" class="readO"></el-input>
                    </td>
					<td style="width:60px">{{ $t('getapi[112]') }}</td>
					<td style="width:140px;">
                        <routejump :urlNo="12">
                        <el-input type="text" size="mini" v-model="part_code" readonly class="mcolor">
                            <i class="el-icon-edit el-input__icon" slot="suffix" @click="selectpart()"></i>
                        </el-input>
                        </routejump></td>
					<td style="width:60px">{{ $t('getapi[149]') }}</td>
					<td style="width:60px;">
                        <el-input type="text" size="mini" v-model="part_version" :readonly="true" class="readO">
                        </el-input></td>
					<td style="width:60px">{{ $t('getapi[4516]') }}</td>
					<td style="width:60px;">
                        <el-button type="primary" size="mini" @click="serclick" >{{$t('getapi[938]')}}</el-button>
                    </td>
				</tr>
			</table>
		</div>
        <div>
            <el-button type="primary" size="mini" @click="endIssue" :disabled="!btn.endIssue">{{$t('getapi[10309]')}}</el-button>
        </div>
        <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
            <li style="width: 100%; margin-top:0px">
                <div id="xpane-0" >
                <vTable
                        :data="dataSet"
                        :loading="loading"
                        queryData="SOMaterialBReportViewInfo"
                        :filter_thousandth="['plan_finish_qty','total_issue_qty','total_return_qty','nofaqty','so_stuff_qty','bomqty']"
                        :header="tableHeader"
                        :height="tableHeight"
                        @handleSelectionChange="handleSelectionChange"
                        @handleSelectionChangeAll="handleSelectionChangeAll"
                        @handleSelectionChangeEnd="handleSelectionChange"
                        ref="singleTable"
                ></vTable>
                </div>
            </li>
        </ul>
        <el-row class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">表名/视图名称:{{ DbTbNames }}</div>
            </el-col>
        </el-row>
        <el-dialog v-dialogDrag :visible.sync="isShowDialog" :title="title" width="25%" :close-on-click-modal="false">
			<el-input type="textarea" :autosize="{ minRows: 15}"  v-model="content"></el-input>
			<span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="isShowDialog = false">{{ $t('getapi[2054]') }}</el-button>
				<el-button type="primary" @click="confirm" size="mini" v-if="value != -1">{{$t('getapi[1146]')}}</el-button>
			</span>
		</el-dialog>
        <serce :isVisible="isVisible" queryData="SOMaterialBReportViewInfo" ref="ser" @getser="serclick"></serce>
        <ctable :isVisible="false" :title="$t('getapi[7107]')" queryData="SOMaterialBReportViewInfo" tabNo="0" ref="ctab" @getctab="sortclick"></ctable>
         <!--选择物料-->
         <selector :isVisible="false" :isBatch="false" :isSplitPage="true" :postUrl="'/Pro/SO/GetSOBReportPopupView'"
                  @callback="getpart" ref="part"></selector>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    export default {
        name:'2_somaterilexereport',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3- Common.reduceTableHeight3,
                    maxHeight: this.$windowSize.tableHeight3- Common.reduceTableHeight3,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3- Common.reduceTableHeight1
            }
        },
        data() {
            return {
                dataSet: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('2_somaterilexereport'), // 当前页数据量
                SelectIndexs: 1, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                selectData: [],
                btn:{
                    endIssue: false
                },
                tableHeader: [],
                schedule_no:'',
                part_code:'',
                part_version:'',
                part_id:'',                
                isShowDialog: false,
                content:'',
                scrollTop:0,
            };
        },
        mounted: function() {
            let that = this;
            that.userData = sessionStorage.getItem('userData');
            that.PlanTypeArray = Array.methods.getPlanType();
            that.authority();
            that.colsort();
            that.$nextTick(function () {
                that.$processdata.initForm()
            })
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            colsort(){
                let that = this;
                that.$loadviewfields.Fileds('SOMaterialBReportViewInfo',0,PFileds=>{
                that.tableHeader=PFileds;		
            });	
            },
            //获取物料
            selectpart() {
                let that = this;
                that.$refs.part.clearInput(true);
            },
            sortclick(val){
                if(val==1){
                    this.colsort();
                }
            },
            // 修改表格顺序
            opentable(){
                this.$refs.ctab.clearInputs(true);
            },
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[10308]"),this.$t("getapi[25]"));
            },
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetOneBtnEnable('ctabel',true);
                //只读权
                if (that.$limits.ReadOnlyRightsView('plv2', 113, 1, that.total)) {
                    if (that.total > 0) {
                        that.$refs.SetBtn.SetButtonEnable('export');
                    } else {
                        that.$refs.SetBtn.SetButtonEnable('');
                    }
                }
                //操作权限-查询级别
                var limits = that.$limits.OperationAuthorityView('plv2', 113, 1, that.total);
                // limits说明： 1 查询权限、2 编辑权限、3 删除权限(列表行数>0)、4 删除权限(列表行数<0)
                switch (limits) {
                    case -1:
                        that.$refs.SetBtn.SetButtonEnable('');
                        break;
                    case 1:
                        that.$refs.SetBtn.SetButtonEnable('export');
                        break;
                    case -2:
                        that.$refs.SetBtn.SetButtonEnable('');
                        break;
                    case 2:
                        that.$refs.SetBtn.SetButtonEnable('export');
                        break;
                    case -3:
                        that.$refs.SetBtn.SetButtonEnable('');
                        break;
                    case 3:
                        that.$refs.SetBtn.SetButtonEnable('export');
                        break;
                    default:
                        break;
                }
                that.btnauthority();
            },
            btnauthority(){
                let that = this
                that.btn.endIssue = false
                if(that.selectData.length > 0){
                    // if (that.$limits.authority('plv4', 38, 1) >0) {
                        that.btn.endIssue = true
                    // }                    
                }
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('2_somateril',val)
                this.getView();
                this.authority();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
                this.authority();
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'SOMaterialBReportViewInfo');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            getpart(data) {
                let that = this;
                that.part_code = data.part_code;
                that.part_id = data.part_id;
                that.part_version = data.part_version;
                that.schedule_no = data.schedule_no;
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;                
                let data = {
                    schedule_no: that.schedule_no,
                    part_id: that.part_id,
                };
                that.$http.urlpost('/Pro/SO/SOMaterilReportView', data, function(res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.DbTbNames = res.DbTbNames;
                        that.loading = false;
                        that.authority();
                    } else {
                        that.loading = false;
                        that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                    }
                });
            },
            // 刷新
            reflash() {
                let that = this;
                that.getView();
            },
            // 导出
            exps() {
                let that = this;
                let parm = {
                    schedule_no: that.schedule_no,
                    part_id: that.part_id,
                };
                that.$refs.SetBtn.SetOneBtnEnable('exps', false);
                that.$http.urlpost('/Pro/SO/SOMaterilReportViewToExecl', parm, function (res) {
                    that.$refs.SetBtn.SetOneBtnEnable('exps', true);
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });
            },
            handleSelectionChange({checked, records }){
                let that = this;
                that.selectData = records;
                that.btnauthority()
            },
            handleSelectionChangeAll({records}){
                let that = this;
                that.selectData = records;
                that.btnauthority()
            },
            endIssue(){
                let that = this
                that.loading = true; 
                let parm = {
                    Lists: that.selectData
                }
                that.$http.urlpost('/Pro/SO/SaveProSoBatchReport', parm, function(res) {
                    if (res.Success == 1) {
                        that.getView();
                        that.loading = false;
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                    }
                    else if (res.Success > 1) {
                        that.loading = false;
                        that.isShowDialog = true
						that.value = res.Success
						that.title = that.$processdata.explainCallbackMsg(res.Msg)
						that.content = res.PopupTxt
                    } else {
                        that.loading = false;
                        that.isShowDialog = true
                        that.value = -1
                        that.title = that.$processdata.explainCallbackMsg(res.Msg)
                        that.content = res.PopupTxt
					}
                    
                });
            }
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
</style>
